export class EmailSenderRoutes
{
	static Home: string = `/`;

	// Provider
	static ProviderList: string = '/provider/list';
	static ProviderNew: string = '/provider/new';
	static ProviderCopy(id: string)
	{
		return `/provider/${id}/new`;
	}
	static ProviderEdit(id: string)
	{
		return `/provider/${id}/edit`;
	}
	static ProviderView(id: string)
	{
		return `/provider/${id}/view`;
	}
	static Verify(provider_id: string)
	{
		return `/provider/${provider_id}/verify`;
	};
	static Send(id: string | null)
	{
		let items = ["/provider"];
		if (id)
			items.push(`/${id}`);
		items.push(`/send`);
		return items.join("");
	}

	// Sent
	static SentList: string = '/sent/list';
}